import { render, staticRenderFns } from "./SPRPagerStats.vue?vue&type=template&id=7bed2f93"
import script from "./SPRPagerStats.vue?vue&type=script&lang=ts"
export * from "./SPRPagerStats.vue?vue&type=script&lang=ts"
import style0 from "./SPRPagerStats.vue?vue&type=style&index=0&id=7bed2f93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports